/* jshint node:true */
'use strict';
var React = require('react');
var Link = require('react-router').Link;

var Navbar = React.createClass({
    getInitialState: function () {
        return {};
    },
    onChange: function () {

    },
    render: function () {
        var spacers = <span> | </span>;

        return (
            <nav>
                <Link to='/' data-route='false'>Home</Link>{spacers}
                <Link to='/rugby/match?gameId=267953&league=267979' data-route='false'>Match</Link>{spacers}
				<Link to='/rugby/report?gameId=267953&league=267979' data-route='false'>Report</Link>{spacers}
                <Link to='/rugby/match?gameId=276525&league=242041&iaas=true' data-route='false'>[ Match IAAS API's ]</Link>{spacers}
                <Link to='/rugby/match?gameId=267951&league=267979&useqa=true' data-route='false'>[ Match QA API's ]</Link>{spacers}
                <Link to='/football/scoreboard' data-route='false'>Football Scoreboard</Link>{spacers}
                <Link to='/rugby/scoreboard' data-route='false'>Rugby Scoreboard</Link>
            </nav>
        );
    }
});
module.exports = Navbar;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/Navbar.jsx
 **/